import StarOutlined from '@ant-design/icons/StarOutlined';
import BellOutlined from '@ant-design/icons/BellOutlined';
import { t } from 'i18n';

const social = {
  id: 'group-social',
  title: t('Social'),
  type: 'group',
  children: [
    { id: 'ratings', title: t('Ratings'), type: 'item', url: '/social/ratings', icon: StarOutlined },
    { id: 'notifications', title: t('Notifications'), type: 'item', url: '/social/notifications', icon: BellOutlined }
  ]
};

export default social;
